
<a
  class="side-nav-item"
  :class="{
    'side-nav-item--active': isActive,
    'side-nav-item--child': isChild
  }"
  :href="item.href || item.to || '#'"
  :aria-current="isActive ? 'page' : undefined"
  @click="handleClick"
  @keydown.enter="handleKeyDown"
  @keydown.space.prevent="handleKeyDown"
>
  <lucide-icon
    :name="item.icon || defaultIcon"
    :size="isChild ? 16 : 18"
    class="side-nav-item__icon"
    aria-hidden="true"
  />
  <span class="side-nav-item__label">
    {{ item.label }}
  </span>
  <span
    v-if="item.badge && !isChild"
    class="side-nav-item__badge"
    :style="{ backgroundColor: item.badgeColor || '#406A94' }"
    :aria-label="`${item.badge} items`"
  >
    {{ item.badge }}
  </span>
</a>
